export default __webpack_public_path__ + "static/media/a004-example1-sc.c7a0bdd9.jpg";